import React, { useState } from 'react';
import { getCookieConsent, acceptAllCookieConsent } from 'utils/cookieConsent';
import { CookieSettingsDialog } from './CookieSettingsDialog';
import {
  BannerBtn,
  BannerInner,
  BannerInnerBtns,
  CookieBanner,
  Description,
  InlineTextButton,
  Title,
} from './styled-components';

export const CookieConsentBanner = () => {
  const [hasConsentCookie, setHasConsentCookie] = useState(() => {
    return Boolean(getCookieConsent());
  });
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  const handleOpenSettings = () => {
    setIsSettingsOpen(true);
  };

  const handleCloseSettings = () => {
    setIsSettingsOpen(false);
  };

  const handleSaveSettings: () => void = () => {
    setHasConsentCookie(true);
  };

  const handleAcceptAll: () => void = () => {
    acceptAllCookieConsent();
    setHasConsentCookie(true);
  };

  if (hasConsentCookie) {
    return null;
  }

  return (
    <>
      <CookieBanner>
        <Title variant="h4">Política de Cookies</Title>
        <BannerInner>
          <Description variant="body1">
            prestamo365.pe utiliza cookies internas y externas con fines estadísticos y para brindarte la mejor
            experiencia en nuestra web. Si sigues navegando con la configuración actual, entenderemos que aceptas
            nuestra política de cookies.{' '}
            <InlineTextButton variant="text" color="primary" onClick={handleOpenSettings}>
              Más información
            </InlineTextButton>
          </Description>
          <BannerInnerBtns>
            <BannerBtn variant="outlined" onClick={handleOpenSettings}>
              Configurar
            </BannerBtn>
            <BannerBtn variant="contained" onClick={handleAcceptAll}>
              Aceptar todo
            </BannerBtn>
          </BannerInnerBtns>
        </BannerInner>
      </CookieBanner>
      <CookieSettingsDialog open={isSettingsOpen} onClose={handleCloseSettings} onSave={handleSaveSettings} />
    </>
  );
};
